import { createFileRoute } from '@tanstack/react-router'

import { Page } from '@/components/page'
import { LabelsScreen } from '@/features/labels/LabelsScreen'

export const Route = createFileRoute('/labels')({ component: LabelsPage })

function LabelsPage() {
  return (
    <Page title="Labels" description="Templates for the labels on your drawers, reels and shelves.">
      <LabelsScreen />
    </Page>
  )
}
